import { request } from "@client/lib/request";
import { type ApiResponse, type HttpApiResponse } from "@client/types/Api";
import { type ContactForm } from "./types";

export default {
  submit: ({
    baseUrl,
    ...args
  }: ContactForm.Api.SubmitRequest): Promise<HttpApiResponse<ContactForm.Api.SubmitResponse>> =>
    request<ApiResponse<ContactForm.Api.SubmitResponse>>({
      method: "POST",
      url: `${baseUrl}/modules/contactForm`,
      body: args
    })
};
